<template>
  <div class="box">
    <GROUPSTAGVUE :isPc="isPc" class="list" v-for="(item,index) in list" :key="index" v-bind="item"/>
  </div>
</template>

<script>
import GROUPSTAGVUE from './components/groupsTag.vue'
import { getMenuList } from '../../../../src/api/api'
import { get as getUser } from '../../../utils/token'
export default {
  components: {
    GROUPSTAGVUE
  },
  data () {
    return {
      user: getUser('user'),
      list: [],
      isPc: this.IsPC()
    }
  },
  mounted () {
    this.getList()
  },
  methods: {
    async getList () {
      const res = await getMenuList(this.user.username)
      if (res.code === 200) {
        this.list = res.detail
      }
    },
    IsPC () {
      const userAgentInfo = navigator.userAgent
      const Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
      let flagPc = true
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flagPc = false
          break
        }
      }
      return flagPc
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  // display: flex;
  // justify-content: space-around;
  // height: 100%;
  // align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: calc(100vh - 50px);
  // padding: 30px  0 0 22px;
  // padding-top: 35px;
  overflow-y: scroll; /*总是显示滚动条*/
  .list {
    margin: 20px auto;
  }
}
</style>
